import * as React from 'react';
import { observer } from 'mobx-react';
import { Modal, ModalChildStyle } from './modal';
import { style } from 'typestyle';
import { CopyBox } from './copy-box';
import { endJustified, horizontal, horizontallySpaced } from 'csstips';
import { ButtonPill } from './button-pill';
import { colorBrand, colorSubtle } from '../theme/color';
import { resetAnchorStyles } from '../theme/reset';
import { px } from 'csx';

export interface VideoAttributionModalModel {
  show: boolean;
  loading: boolean;
  attribution: string;
}

export interface VideoAttributionModalProps {
  model: VideoAttributionModalModel;
  onRequestClose(): void;
  i18n?: {
    title: string;
    strap: string;
    why: string;
    empty: string;
    close: string;
  }
}

@observer
export class VideoAttributionModal extends React.Component<VideoAttributionModalProps, any> {
  render() {
    const { model, i18n = VideoAttributionModal.i18n, onRequestClose } = this.props;

    return (
      <Modal show={model.show} onRequestClose={onRequestClose}>
        {model.show && (
          <div className={VideoAttributionModal.styles.container}>
            <h3>{i18n.title}</h3>
            <p>{i18n.strap} <a target="_blank" href="/faq#why-do-i-need-to-credit-the-artist" className={VideoAttributionModal.styles.link}>{i18n.why}</a></p>
            {model.loading && (
              <div className={VideoAttributionModal.styles.loading}>Loading...</div>
            )}
            {!model.loading && model.attribution && (
              <CopyBox content={model.attribution} />
            )}
            {!model.loading && !model.attribution && (
              <div>{i18n.empty}</div>
            )}
            <div className={VideoAttributionModal.styles.buttons}>
              <ButtonPill onClick={onRequestClose}>
                {i18n.close}
              </ButtonPill>
            </div>
          </div>
        )}
      </Modal>
    )
  }

  static i18n = {
    title: 'Video description attribution',
    strap: 'Please copy the following into your YouTube video description.',
    why: 'Why do I have to do this? 🤔',
    empty: 'There are no attributions to copy',
    close: 'Close',
  };
  
  static styles = {
    container: style({
      ...ModalChildStyle,
      $nest: {
        '&> p': {
          margin: '0 0 30px 0'
        }
      }
    }),
    link: style({
      color: colorBrand.toString(),
      $nest: { ...resetAnchorStyles(colorBrand.toString()) }
    }),
    buttons: style({
      ...horizontal,
      ...horizontallySpaced(10),
      ...endJustified,
      margin: '30px 0 0 0'
    }),
    loading: style({
      padding: px(30),
      textAlign: 'center',
      color: colorSubtle.toString()
    })
  };
}